import React from 'react'
import AlertDialog from './AlertDialog'
import { NumericFormat as NumberFormat } from 'react-number-format';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import ReactHtmlParser from 'react-html-parser'; 


const NF = (props) => {
    return (
        <NumberFormat  value={props.value} 
        displayType={'text'} 
        thousandSeparator={true} 
        decimalSeparator={'.'}
        decimalScale={2}
        fixedDecimalScale={true}
        suffix={props.suffix} 
        prefix={props.prefix} 
        />
    )
}

export const  Alerts1 = (props) => {
    return(  
        <>
        <AlertDialog 
        open={props.open} 
        title='Confirm Remove' 
        content={'Are you sure you wish to Remove Array ' + (props.state.currentArray + 1) + '?'}
        showopen={true}
        showclose={true}
        okPrompt="Yes" 
        cancelPrompt="No" 
        onClose={props.onClose}
    />
    </>
    );
}



export const Alerts2Orig = (props) => {
    const panelArrays = props.state.panelArrays[props.state.currentArray]
    const calcData = panelArrays ? panelArrays.calcData : null
    const max_panel_energy = calcData? calcData.panel_energy : 0 ;
    const panel_production_energy = calcData? calcData.panel_production_energy  : 0;
    const panel_self_consumption = calcData ? calcData.panel_useable_energy : 0;
    const panel_and_battery_useable_energy =calcData ? calcData.panel_and_battery_useable_energy : 0;
    const gird_sale_sc = calcData ? panel_production_energy - panel_self_consumption : 0;
    let grid_sale_panelbattery_sc = calcData ? (panel_production_energy - panel_and_battery_useable_energy) : 0;
    if(isNaN(parseFloat(grid_sale_panelbattery_sc))) 
        grid_sale_panelbattery_sc = 0
    
    const elecconsumption = calcData ? calcData.elecconsumption : 0
    let report = ""
    if(calcData && calcData.report > "" ) report = calcData.report
    if(calcData && calcData.mgd003_report > "") report = calcData.mgd003_report
    return(
        <>
    <AlertDialog 
        open={props.open} 
        showopen={true}
        showclose={false}
        title={`Data Calculations for Array ${props.state.currentArray+1} `}
        content={panelArrays && <>
        <Typography  style={{color: '#000', marginLeft: 5, fontSize: 16, fontWeight: 400, textDecoration: 'underline', marginBottom: 10}} >{panelArrays.description}</Typography  >
        <Typography  style={{color: '#000', textAlign: 'center', fontSize: 14, fontWeight: 600, textDecoration: 'none', marginTop: 10}} >{panelArrays.numPanels + ' X ' + panelArrays.panelType}</Typography  >
            <TableContainer>
                <Table stickyHeader={true} >
                    <TableBody>
                        <TableRow>
                            <TableCell>Max Energy from Panels:</TableCell>
                            <TableCell><NF value={max_panel_energy} prefix="" suffix= " kWh" /></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Max Available After Iradiation and Shading:</TableCell>
                            <TableCell><NF prefix="" value={(panel_production_energy)} suffix=" kWh" /></TableCell>
                        </TableRow>
                        {elecconsumption === 0 &&  <TableRow>
                           <TableCell colSpan={2} >Electrcity Consumption is not completed so cannot calcuale Self Consumption Data</TableCell>
                        </TableRow> }
                        {elecconsumption !== 0 && <TableRow>
                            <TableCell>Max Available for Self Consumption (Panel Only):</TableCell>
                            <TableCell><NF prefix="" value={(panel_self_consumption )} suffix=" Wh" /></TableCell>
                        </TableRow>  }
                        {elecconsumption !== 0 && <TableRow>
                            <TableCell>Max Available for Self Consumption (Panel + Battery):</TableCell>
                            <TableCell><NF prefix="" value={panel_and_battery_useable_energy} suffix=" Wh" /></TableCell>
                        </TableRow>}
                        {elecconsumption !== 0 && <TableRow>
                            <TableCell>Max Available for Sale to Grid (Panel Only):</TableCell>
                            <TableCell><NF prefix="" value={gird_sale_sc} suffix=" Wh" /></TableCell>
                        </TableRow>  }
                        {elecconsumption !== 0 && <TableRow>
                            <TableCell>Max Available for Sale to Grid (Panel + Battery):</TableCell>
                            <TableCell><NF prefix="" value={grid_sale_panelbattery_sc} suffix=" Wh" /></TableCell>
                        </TableRow> }  
                        {report &&  <><TableRow><TableCell colSpan={2} >Calculation Report</TableCell></TableRow>
                        <TableRow><TableCell colSpan={2} >{ReactHtmlParser(report)}</TableCell></TableRow>
                        </>
                        }
                    </TableBody>
                </Table>
            </TableContainer></>
        }
        okPrompt="Close" 
        onClose={props.onClose}
    />
    </>
    );
}

// Alerts2 - Just Show reports overall
export const Alerts2 = (props) => {
    console.log('Alerts2', props)
    const panelArrays = props.state.panelArrays[props.state.currentArray??0]??[];
    const calcData = panelArrays ? panelArrays.calcData : null
    const max_panel_energy = calcData? calcData.panel_energy : 0 ;
    const panel_production_energy = calcData? calcData.panel_production_energy  : 0;
    const panel_self_consumption = calcData ? calcData.panel_useable_energy : 0;
    const panel_and_battery_useable_energy =calcData ? calcData.panel_and_battery_useable_energy : 0;
    const gird_sale_sc = calcData ? panel_production_energy - panel_self_consumption : 0;
    let grid_sale_panelbattery_sc = calcData ? (panel_production_energy - panel_and_battery_useable_energy) : 0;
    if(isNaN(parseFloat(grid_sale_panelbattery_sc))) 
        grid_sale_panelbattery_sc = 0

    
    const elecconsumption = calcData ? calcData.elecconsumption : 0
    let report = ""
    if(calcData && calcData.report > "" ) report = calcData.report
    else if(calcData && calcData.mgd003_report > "") report = calcData.mgd003_report
    else report = "<div>Sorry There is no Report Available to Show</div>"
    return(
        <>
    <AlertDialog 
        open={props.open} 
        showopen={true}
        showclose={false}
        title="Data Calculations for Arrays"
        content={panelArrays && 
        <>{ReactHtmlParser(report)}</>
        }
        okPrompt="Close" 
        onClose={props.onClose}
    />
    </>
    );
}

export const  Alerts3 = (props) => {

    let content = "Calculations Completed.  *** PLEASE NOTE PRESENTATION & OTHER DOCS NOT GENERATED ***   Check the 'Create Documents' checkbox and then Re-Calculate to Produce the Presentation and other Documents"
    let title = 'Calculations Completed'
    if(props.state.create_documents ) {
        title =  'Presentation Slides Completed' 
        content = 'The Presentation Slides have completed Generating and are ready to view / use.'
    } 
    return(  
        <>
        <AlertDialog 
        open={props.open} 
        title={title}
        content={content}
        showopen={true}
        showclose={true}
        okPrompt="Ok" 
        // cancelPrompt="No" 
        onClose={props.onClose}
    />
    </>
    );
    
}

export const  Alerts4 = (props) => {
    return(  
        <>
        <AlertDialog 
        open={props.open} 
        title='Restart Where you left off?' 
        content={'Your last page was ' + (props.preview_page) + '. Would you like to resume from this page?'}
        showopen={true}
        showclose={true}
        okPrompt="Yes" 
        cancelPrompt="No" 
        onClose={props.onClose}
    />
    </>
    );
}
